import { render, staticRenderFns } from "./gasto-form.vue?vue&type=template&id=18943af4&scoped=true"
import script from "./gasto-form.vue?vue&type=script&lang=js"
export * from "./gasto-form.vue?vue&type=script&lang=js"
import style0 from "./gasto-form.vue?vue&type=style&index=0&id=18943af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18943af4",
  null
  
)

export default component.exports